import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import AwesomeIcon from "../AwesomeIcon";
function Alert(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    onClick = _ref.onClick,
    dynamicMessagePart = _ref.dynamicMessagePart,
    messageKey = _ref.messageKey,
    showProgress = _ref.showProgress;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classNames("bg-red-600 py-4 px-5 hidden sm:flex space-x-3 items-center text-base text-gray-100", _defineProperty({}, className, className)),
    onClick: onClick
  }, icon && /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon
  }), /*#__PURE__*/React.createElement("p", null, t(messageKey, dynamicMessagePart))), showProgress && /*#__PURE__*/React.createElement("div", {
    className: " bg-yellow-400 h-2 relative"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-[30%] bg-gradient-to-r h-2 absolute animate-moveBar from-transparent to-gray-800"
  })));
}
export default Alert;